import React from 'react';
import GridTableFooter from '../GridUsuario/GridTableFooter';
import { FaPen, FaHashtag, FaTrash } from 'react-icons/fa';
import { NormalizedLookupRow } from './types';

interface ProductLookupTableProps {
  rows: NormalizedLookupRow[];
  pagAtual: number;
  pageCount: number;
  totalRecords: number;
  forcePage: number;
  onPageChange: (event: { selected: number }) => void;
  onSelect: (row: NormalizedLookupRow) => void;
  onEdit: (row: NormalizedLookupRow) => void;
  onDelete?: (row: NormalizedLookupRow) => void;
}

const ProductLookupTable = ({
  rows,
  pagAtual,
  pageCount,
  totalRecords,
  forcePage,
  onPageChange,
  onSelect,
  onEdit,
  onDelete,
}: ProductLookupTableProps) => (
  <div className="user-table">
    <div className="user-table__scroll">
      <table className="user-table__table">
        <thead>
          <tr>
            <th>STATUS</th>
            <th>ID</th>
            <th>DESCRIÇÃO</th>
            <th>IDENTIFICADOR ALT.</th>
            <th>AÇÕES</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={String(row._id)} className="user-table__row product-lookup-table__row">
              <td
                className="user-table__cell user-table__cell--center product-lookup-table__cell--select"
                data-label="Status"
                onClick={() => onSelect(row)}
                onKeyDown={(e) => e.key === 'Enter' && onSelect(row)}
                role="button"
                tabIndex={0}
              >
                {row._active ? (
                  <span className="user-table__status user-table__status--active">
                    <span className="user-table__status-dot" />
                    ATIVO
                  </span>
                ) : (
                  <span className="user-table__status user-table__status--inactive">
                    <span className="user-table__status-dot" />
                    INATIVO
                  </span>
                )}
              </td>
              <td
                className="user-table__cell user-table__cell--center product-lookup-table__cell--select"
                data-label="ID"
                onClick={() => onSelect(row)}
                onKeyDown={(e) => e.key === 'Enter' && onSelect(row)}
                role="button"
                tabIndex={0}
              >
                <span className="user-table__id">{row._id}</span>
              </td>
              <td
                className="user-table__cell product-lookup-table__cell--description product-lookup-table__cell--select"
                data-label="Descrição"
                onClick={() => onSelect(row)}
                onKeyDown={(e) => e.key === 'Enter' && onSelect(row)}
                role="button"
                tabIndex={0}
              >
                <span className="user-table__name product-lookup-table__description">
                  {row._description || '—'}
                </span>
              </td>
              <td
                className="user-table__cell user-table__cell--alt-id product-lookup-table__cell--select"
                data-label="Identificador alt."
                onClick={() => onSelect(row)}
                onKeyDown={(e) => e.key === 'Enter' && onSelect(row)}
                role="button"
                tabIndex={0}
              >
                <div className="user-table__login">
                  <FaHashtag size={12} />
                  <span>{row._alternativeId || '—'}</span>
                </div>
              </td>
              <td
                className="user-table__cell user-table__cell--center user-table__cell--actions"
                data-label="Ações"
              >
                <div className="user-table__actions-group">
                  <button
                    type="button"
                    className="user-table__edit-btn"
                    title="Editar"
                    onClick={() => onEdit(row)}
                  >
                    <FaPen size={14} />
                  </button>
                  {onDelete ? (
                    <button
                      type="button"
                      className="user-table__edit-btn user-table__edit-btn--danger"
                      title="Excluir"
                      onClick={() => onDelete(row)}
                    >
                      <FaTrash size={14} />
                    </button>
                  ) : null}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

    <GridTableFooter
      pagAtual={pagAtual}
      pageCount={pageCount}
      totalRecords={totalRecords}
      forcePage={forcePage}
      onPageChange={onPageChange}
      totalRecordsText={`Total: ${totalRecords}`}
      rightSlot={
        <span className="user-table__footer-hint">Clique na linha para selecionar</span>
      }
    />
  </div>
);

export default ProductLookupTable;
